import { ArrowLeft } from 'lucide-react';
import { useBackNavigation } from '../../hooks/useBackNavigation';
import { CachedTermlyPolicyFrame } from './CachedTermlyPolicyFrame';

interface TermlyPolicyPageProps {
  policyId: string;
  title: string;
  description: string;
}

export function TermlyPolicyPage({ policyId, title, description }: TermlyPolicyPageProps) {
  const goBack = useBackNavigation();
  const policyUrl = `https://app.termly.io/policy-viewer/policy.html?policyUUID=${policyId}`;

  return (
    <div className="min-h-screen bg-[#0D1117]">
      <div className="mx-auto w-full max-w-5xl px-4 py-8 md:py-10">
        <button
          onClick={goBack}
          className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-4"
          aria-label="Go back"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>

        <h1 className="text-2xl font-bold text-white mb-1">{title}</h1>
        <p className="text-sm text-slate-500 mb-6">{description}</p>

        <div className="rounded-2xl overflow-hidden ring-1 ring-white/[0.08] shadow-2xl shadow-black/40 bg-[#0B0F14]">
          <CachedTermlyPolicyFrame policyUrl={policyUrl} title={title} />
        </div>

        <p className="text-xs text-slate-500 mt-4">
          If this page does not load, open it directly:{' '}
          <a
            href={policyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-teal-400 hover:text-teal-300 underline"
          >
            View policy
          </a>
          .
        </p>
      </div>
    </div>
  );
}
